<template>
  <v-dialog v-model="currentRoot.inputs.displayForm" width="800" :eager="true">
    <template v-slot:activator="{ on }">
      <v-btn
        :icon="iconOnly"
        :color="buttonColor"
        dark
        v-on="on"
        v-bind="{ [size]: true }"
      >
        <v-icon v-if="buttonIconName != null">{{ buttonIconName }}</v-icon>
        <span v-else>{{ buttonName }}</span>
      </v-btn>
    </template>
    <exo-form :root="currentRoot">
      <CustomEvasiveScenarioForm
        :scenario="scenario"
        :missionId="missionId"
        :spaceObject="spaceObject"
        v-on:mounted="changeRoot($event)"
      />
    </exo-form>
  </v-dialog>
</template>

<script>
import axios from '../../services/axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import errorMixin from '../../mixins/logHandler.js'
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import { mapActions } from 'vuex'
Vue.use(VueAxios, axios)
import CustomEvasiveScenarioForm from './CustomEvasiveScenarioForm'

export default {
  name: 'CustomEvasiveScenarioEditButton',

  mixins: [errorMixin, formMixin, numericalMixin],

  props: {
    scenario: {
      type: Object,
      default: null
    },
    missionId: {
      type: String,
      default: null
    },
    spaceObject: { type: Object, default: null },
    buttonName: {
      type: String,
      default: 'New custom scenario'
    },
    buttonIconName: {
      type: String,
      default: null
    },
    iconOnly: {
      type: Boolean,
      default: false
    },
    buttonColor: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'small'
    }
  },

  components: { CustomEvasiveScenarioForm },

  computed: {},
  watch: {
    'currentRoot.inputs.displayForm'(newValue) {
      if (!newValue) {
        this.refreshCustomEvasiveScenarios()
      }
    }
  },

  data() {
    return { currentRoot: this, enableFormCache: false }
  },

  methods: {
    ...mapActions(['refreshCustomEvasiveScenarios']),
    getCurrentFormType() {
      return 'CustomEvasiveScenarioDefinition'
    },
    changeRoot(root) {
      this.currentRoot = root
    }
  }
}
</script>

<style scoped>
.cardheader {
  background: #3be287;
}
</style>
